import { onBeforeUnmount, onMounted } from 'vue'
// import { throttle } from '@/js/helper.js'

/**
 * element resize event 
 * @param {HTMLElement} target - resize event 적용할 element
 * @param {function} callback - resize event handler (default: throttle)
 */
export function useResizeObserver(callback = (entries) => console.log(entries)) {
  // const throttleCallback = throttle(callback)
  
  const observer = new ResizeObserver(entries => {
    // throttleCallback(entries)
    callback(entries)
  })

  return observer
}